import React from "react";
import {
  getFullMonthNameWithYear,
  calculateNetSalary,
  calculateGrossSalary,
  currencyFormat
} from "@utils/utils";

const PayslipTable = ({ payslipData }) => {
  return (
    <table style={table}>
       <style>
          {`
            @media print {
              .header {
                display: table-header-group;
              }
            }
          `}
        </style>
      <thead style={header}>
        <tr>
          <th style={cellFormat}>Month</th>
          <th style={cellFormat}>Gross Salary</th>
          <th style={cellFormat}>Bonus</th>
          <th style={cellFormat}>Deductions</th>
          <th style={{ ...cellFormat, fontWeight: "bold" }}>Net Salary</th>
        </tr>
      </thead>
      <tbody>
        {payslipData?.map(
          (
            payroll,
            index
          ) => (
            <tr key={index}>
              <td style={cellFormat}>
                {getFullMonthNameWithYear(payroll.salary_date)}
              </td>
              <td style={cellFormat}>
                {calculateGrossSalary(payroll.basic_salary, payroll.medical_allowance)}
              </td>
              <td style={cellFormat}>{currencyFormat(payroll.bonus, true)}</td>
              <td style={cellFormat}>{currencyFormat(payroll.deductions+payroll.tax, true)}</td>
              <td style={{ ...cellFormat, fontWeight: "bold" }}>
                {currencyFormat(calculateNetSalary(
                  payroll
                ), true)}
              </td>
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

const table = {
  width: "100%",
  textAlign: "left",
  marginLeft: "auto",
  marginRight: "auto",
};
const header = { backgroundColor: "#83ace6", color: "white" };
const cellFormat = {
  padding: "3px",
  border: "1px solid lightgray",
};

export default PayslipTable;
